"use client";

import React, { useState } from "react";
import { usePathname } from "next/navigation";

import { useAuth } from "@/features/auth/contexts/AuthContext";
import { useCustomerCartSync } from "@/features/shop/cart/useCustomerCartSync";
import { AuthenticatedAppShell } from "./authenticated-app-shell";
import { PublicAppShell } from "./public-app-shell";

export const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const [searchValue, setSearchValue] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const { userAccount: user, signOut } = useAuth();
  const pathname = usePathname();
  useCustomerCartSync();
  const isShopRoute = pathname.startsWith("/shop");
  const isPublicStorefrontRoute = isShopRoute || pathname === "/";

  if (isPublicStorefrontRoute) {
    return (
      <PublicAppShell
        searchValue={searchValue}
        onSearchChange={setSearchValue}
      >
        {children}
      </PublicAppShell>
    );
  }

  return (
    <AuthenticatedAppShell
      user={user}
      isSidebarOpen={isSidebarOpen}
      isSidebarCollapsed={isSidebarCollapsed}
      isShopRoute={isShopRoute}
      onMenuToggle={() => setIsSidebarOpen((value) => !value)}
      onSidebarClose={() => setIsSidebarOpen(false)}
      onSidebarCollapseToggle={() => setIsSidebarCollapsed((value) => !value)}
      onSignOut={signOut}
    >
      {children}
    </AuthenticatedAppShell>
  );
};
